import React from 'react'
import './features.css'

const Features = () => {
  return <div />
}

export default Features
